import { BaseEntity, getCachedStructureEntity } from ".";
import { IGet_characters_character_id_blueprints_200_ok } from "../service/esiclient";
import { getCachedAssetEntity } from "./AssetEntityCache";
import { getCachedBlueprintEntity } from "./BlueprintEntityCache";
import { getCachedCharacterEntity } from "./CharacterEntityCache";
import { getCachedStationEntity } from "./StationEntityCache";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class CharacterBlueprintEntity extends BaseEntity {
  constructor(id: number, props: any, character_id: number) {
    super(id, props);
    this._character_id = character_id;
    this._dataTypeName = "Character Blueprint";
  }

  async toJson(lightversion?: boolean): Promise<Excel.EntityCellValue> {
    //const id = this._id;
    const props: Partial<IGet_characters_character_id_blueprints_200_ok> = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      const characterEntity = await getCachedCharacterEntity(this._character_id);
      if (characterEntity !== null) {
        entity.properties["owner"] = await characterEntity.toJson();
      }
      let bpType = " (Copy)";
      if (props.runs && props.runs === -1) {
        bpType = " (Original)";
      }
      if (props.location_id && props.location_flag && props.location_flag.toString() === "Hangar") {
        const stationEntity = await getCachedStationEntity(props.location_id);
        if (stationEntity !== null) {
          entity.properties["location"] = await stationEntity.toJson(true);
          //delete entity.properties["location_id"];
        }
      } else if (props.location_id) {
        const assetEntity = await getCachedAssetEntity(props.location_id);
        if (assetEntity !== null) {
          entity.properties["location"] = await assetEntity.toJson();
          //delete entity.properties["location_id"];
        } else {
          if (props.location_flag && props.location_flag == "Hangar") {
            const structureEntity = await getCachedStructureEntity(props.location_id, this._character_id);
            if (structureEntity !== null) {
              entity.properties["location"] = await structureEntity.toJson(true);
              //delete entity.properties["location_id"];
            }
          }
        }
      }
      // - Type properties
      if (Object.prototype.hasOwnProperty.call(props, "type_id") && props.type_id) {
        const blueprintTypeEntity = await getCachedTypeEntity(props["type_id"]);
        if (entity.properties && blueprintTypeEntity !== null) {
          // - Name
          entity.properties["name"] = {
            type: Excel.CellValueType.string,
            basicValue: blueprintTypeEntity.props["name"] + bpType,
          };
          entity.text = blueprintTypeEntity.props["name"] + bpType;
          // - Base Price
          if (Object.prototype.hasOwnProperty.call(blueprintTypeEntity.props, "basePrice")) {
            entity.properties["basePrice"] = {
              type: Excel.CellValueType.formattedNumber,
              basicValue: blueprintTypeEntity.props.basePrice === "None" ? 0 : blueprintTypeEntity.props.basePrice,
              numberFormat: "##0",
              propertyMetadata: {
                sublabel: "ISK",
              },
            };
          }
          if (!lightversion || lightversion == null) {
            const resultingBlueprintEntity = await getCachedBlueprintEntity(props.type_id);
            if (resultingBlueprintEntity != null)
              entity.properties["blueprint_data"] = await resultingBlueprintEntity.toJson();
          }
        }
        // - Blueprint Type Id
        //delete entity.properties["type_id"];
        if (lightversion) {
          entity.properties["type_id"] = {
            type: Excel.CellValueType.formattedNumber,
            basicValue: props["type_id"],
            numberFormat: "##0",
          };
          delete entity.properties["type"];
        }
      }
      // - Activities
      /*
      if (Object.prototype.hasOwnProperty.call(props, "activities")) {
        const activities = ["copying", "invention", "manufacturing", "reaction", "research_material", "research_time"];
        for (let i = 0; i < activities.length; i++) {
          const activity = activities[i];
          if (entity.properties && Object.prototype.hasOwnProperty.call(props.activities, activity)) {
            entity.properties[activity] = await makeActivityEntity(props.activities[activity], activity);
          }
        }
      }
      */
    }

    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };

    return entity;
  }
}
